



































































import { Component } from "vue-property-decorator";
import ViewBase from "@/utils/ViewBase";
// import GlobalFooter from './layouts/GlobalFooter'
import { setUser, appId } from "@/store";
import { login, logout } from "@/api/login";
import findPasswordModal from "./findPasswordModal.vue";

@Component({
  components: {
    // GlobalFooter
    findPasswordModal
  }
})
export default class Main extends ViewBase {
  logging: any = false;
  error = "";
  form = null;
  query: any = {
    name: "",
    email: "",
    password: ""
  };
  findPasswordModalShow = false;
  disabled: boolean = false;

  async onSubmit(e: any) {
    e.preventDefault();
    const flag = await (this.form as any).validateFields();
    try {
      if (flag) {
        const query = {
          ...flag
        };
        this.disabled = true;
        this.logging = true;
        try {
          const reg = /(^\s*|\s*$)/g;
          const { data } = await login({
            name: (query.name + "").replace(reg, ""),
            email: (query.name + "").replace(reg, ""),
            password: (query.password + "").replace(reg, "")
          });
          setUser({
            id: data.channelManagerUserId,
            name: data.realName,
            channel_id: data.channelId,
            token: data.token,
            language: this.$store.state.setting.en
          });
          this.$router.push("/");
          this.disabled = false;
          this.logging = false;
        } catch (ex) {
          const msg = ex.msg || ex.code ? `${ex.code} ${ex.msg}` : String(ex);
          this.$message.error(msg).then(() => {
            this.logging = false;
            this.disabled = false;
          });
        } finally {
        }
      }
    } catch (ex) {
      this.handleError(ex);
    }

    // setUser({ id: '12', name: 'admin' })
    //  (this.form as any).validateFields((err: any) => {
    //     if (!err) {
    //       this.logging = true
    // this.$axios.post('/login', {
    //   name: this.form.getFieldValue('name'),
    //   password: this.form.getFieldValue('password')
    // }).then((res) => {
    //   this.logging = false
    //   const result = res.data
    //   if (result.code >= 0) {
    //     const user = result.data.user
    //     this.$router.push('/home')
    //     this.$store.commit('account/setuser', user)
    //     this.$message.success(result.message, 3)
    //   } else {
    //     this.error = result.message
    //   }
    // })
  }

  showFindPasswordModal() {
    this.findPasswordModalShow = true;
  }
}
